/**
 * Resource hủy dự toán
 * NMDUC1 27/4/2023
 */
export default {
  Title: 'Hủy dự toán',
  DecisionDate: 'Ngày QĐ',
  DecisionDateTitle: 'Ngày quyết định',
  DecisionNo: 'Số QĐ',
  DecisionNoTitle: 'Số quyết định',
  Description: 'Diễn giải',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày CT',
  RefDateTitle: 'Ngày chứng từ',
  PostedDate: 'Ngày HT',
  PostedDateTitle: 'Ngày hạch toán',
  RefNo: 'Số CT',
  RefNoTitle: 'Số chứng từ',
};
